import './BrowserFixes';

if(window.Modernizr && !window.Modernizr.objectfit) {
    import('./ObjectFit');
}
